import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { getDefaultWeight } from "../../utils/typography/getDefaultWeight";
import styles from "../../styles/typography/sk-Typography.module.css";
export function Heading({ as: Tag, variant, weight, className, children, ...restProps }) {
    const Component = (Tag || "h1");
    const typographyWeight = getDefaultWeight(variant, weight);
    return (_jsx(Component, { ...restProps, className: clsx(styles.main, styles[variant], styles[typographyWeight], className), children: children }));
}
Heading.displayName = "Heading";
//# sourceMappingURL=Heading.js.map